import { useAxiosLoader } from '../../utils/hooks/useAxiosLoader'
import { Loader } from './index'

const Axios = () => {
    const loading = useAxiosLoader()
    return loading ? <Loader /> : null
}

export default Axios
